module.exports = __webpack_public_path__ + "static/turquia-001.thumb-95d0336ea4dfd26bdf1de1aff6c85068.jpg";